import type { ProjectItem } from "../translations/types";

interface AppCatalogItem {
	titleJa: string;
	titleEn: string;
	descriptionJa: string;
	descriptionEn: string;
	logo: string | null;
	appStoreId?: string;
}

// App Store Connectのカタログを基準に、学習・試験対策系と内部テスト用アプリを除外。
// 公開終了などでストアページを取得できないアプリには、壊れたリンクを表示しない。
const appCatalog: AppCatalogItem[] = [
	{
		titleJa: "ThreadMaster",
		titleEn: "ThreadMaster",
		descriptionJa: "5ch、爆サイ、ガールズちゃんねるなど、複数掲示板に対応した統合ブラウザ。SwiftUI、Tuist、Realmを用いたモジュラー構成で継続運用。",
		descriptionEn: "A unified browser for multiple discussion boards, maintained with a modular SwiftUI, Tuist, and Realm architecture.",
		logo: "/app-icons/threadmaster.png",
		appStoreId: "6455370741",
	},
	{
		titleJa: "RUNEDIT：ランニング記録をSNSシェア",
		titleEn: "RUNEDIT — Share Running Records",
		descriptionJa: "HealthKitのランニング記録とルートを読み込み、SNS向けの共有画像をテーマや写真から作成できるアプリ。",
		descriptionEn: "Turns HealthKit running records and routes into customizable images designed for sharing on social media.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/97/97/ae/9797ae2e-f271-8ba9-973d-e9bf42b04ff8/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg",
		appStoreId: "6789439744",
	},
	{
		titleJa: "圏外地図 - MAPCODEオフライン地図",
		titleEn: "Offline Mapcode",
		descriptionJa: "MAPCODEの確認と地点共有、地図の端末保存に対応し、通信できない場所でも使えるオフライン地図アプリ。",
		descriptionEn: "An offline map app for checking and sharing MAPCODE locations and saving map regions for use without connectivity.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/c4/46/f5/c446f588-9086-6e51-a3b4-765440a10bc1/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg",
		appStoreId: "6795403544",
	},
	{
		titleJa: "現場ピン",
		titleEn: "Genba Pin",
		descriptionJa: "現場の位置情報をチームで管理・共有するための地図アプリ。MAPCODEを活用した地点登録にも対応。",
		descriptionEn: "A field-location app for teams to manage and share work sites, including location registration with MAPCODE.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/PurpleSource211/v4/d9/0d/a2/d90da277-6a11-1841-a063-6b75b51f64ca/Placeholder.mill/100x100bb.png",
	},
	{
		titleJa: "PipePlan",
		titleEn: "PipePlan",
		descriptionJa: "Φ28イレクターパイプを使ったDIY製作の設計、2D・3Dプレビュー、必要部材と切断案の計算を支援。",
		descriptionEn: "Helps plan DIY builds with 28 mm pipes through 2D and 3D previews, parts lists, and cutting calculations.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/fe/31/7d/fe317dc3-0c17-d54f-4550-5087e5756ee2/AppIcon-0-0-1x_U007epad-0-1-85-220.png/100x100bb.jpg",
		appStoreId: "6795428878",
	},
	{
		titleJa: "PreparePrint",
		titleEn: "PreparePrint",
		descriptionJa: "写真の撮影日を焼き込み、L判向けの配置や向きを調整してまとめて印刷できるmacOSアプリ。",
		descriptionEn: "A macOS app for adding capture dates, arranging photos for L-size prints, and preparing them for batch printing.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple221/v4/21/f4/7d/21f47d73-9e97-c0da-9a31-7d1eedb74dea/AppIcon-0-0-85-220-0-5-0-2x.png/100x100bb.png",
		appStoreId: "6782952728",
	},
	{
		titleJa: "Shiftas+",
		titleEn: "Shiftas+",
		descriptionJa: "複数スタッフ・複数店舗のシフトをリアルタイム共有できる、iOS・Android・Web対応のシフト管理サービス。",
		descriptionEn: "A cross-platform shift service for managing and sharing schedules across multiple staff members and workplaces.",
		logo: "/app-icons/shiftas.png",
		appStoreId: "1169500173",
	},
	{
		titleJa: "TapShift - シフト表作成",
		titleEn: "TapShift — Shift Planner",
		descriptionJa: "店舗向けのシフト表作成、スタッフ管理、必要人数の確認、勤務時間・給与集計をiPhoneで完結。",
		descriptionEn: "An iPhone shift planner for staff management, staffing requirements, work-hour totals, and payroll estimates.",
		logo: "/app-icons/tapshift.png",
		appStoreId: "1540219001",
	},
	{
		titleJa: "ペアカレ",
		titleEn: "PairCale",
		descriptionJa: "カップルや夫婦の勤務シフトをリアルタイムで同期し、二人の予定を見やすく共有できるカレンダー。",
		descriptionEn: "A shared calendar that synchronizes work shifts in real time for couples and partners.",
		logo: "/app-icons/paircale.png",
		appStoreId: "1376462458",
	},
	{
		titleJa: "Crash Report Viewer",
		titleEn: "Crash Report Viewer",
		descriptionJa: "Appleプラットフォームの.crash・.ipsファイルを解析し、スタックトレースやスレッドを整理して表示する開発者ツール。",
		descriptionEn: "A developer tool that parses .crash and .ips files and presents stack traces and threads in a readable structure.",
		logo: "/app-icons/crashreport.png",
		appStoreId: "6751777982",
	},
	{
		titleJa: "MAX計算機：ベンチプレス・筋トレ1RM",
		titleEn: "1RM Max Calculator",
		descriptionJa: "複数の計算式からベンチプレス、スクワット、デッドリフトの1RMを算出し、記録と進捗を管理。",
		descriptionEn: "Calculates one-rep max values for major lifts using multiple formulas and tracks training progress.",
		logo: "/app-icons/maxcalc.png",
		appStoreId: "1110502852",
	},
	{
		titleJa: "BPM計測：タップ＆自動解析",
		titleEn: "BPM Measure: Tap & Analyzer",
		descriptionJa: "タップテンポと楽曲解析でBPMを測定し、音楽のピッチ・テンポ調整にも対応する音楽ツール。",
		descriptionEn: "A music utility for tap-tempo and automatic BPM analysis with real-time pitch and tempo adjustment.",
		logo: "/app-icons/bpmcontrol.png",
		appStoreId: "1123366285",
	},
	{
		titleJa: "ルーレット - あなたの決断を後押し",
		titleEn: "Roulette — Make a Decision",
		descriptionJa: "項目、当選比率、BGMをカスタマイズし、日常の選択や抽選に使えるルーレットアプリ。",
		descriptionEn: "A customizable roulette app for everyday choices and drawings, with adjustable odds and sound.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple126/v4/44/01/c2/4401c297-223f-8c15-9d6d-c39e85974575/AppIcon-0-0-1x_U007ephone-0-85-220.jpeg/100x100bb.jpg",
		appStoreId: "6476884252",
	},
	{
		titleJa: "メリーさん",
		titleEn: "Mary-san",
		descriptionJa: "メッセージと選択肢で物語が分岐する、都市伝説を題材にしたチャット形式の短編ホラーゲーム。",
		descriptionEn: "A short chat-style horror game inspired by an urban legend, with branching choices and endings.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/56/8f/f7/568ff76c-d91f-5b67-8b62-0e6f4af8fa9d/AppIcon-0-0-1x_U007emarketing-0-6-85-220.png/100x100bb.jpg",
		appStoreId: "1355473554",
	},
	{
		titleJa: "Worker",
		titleEn: "Worker",
		descriptionJa: "働いている時間と増えていく給与をミリ秒単位で可視化する、シンプルなワークタイマー。",
		descriptionEn: "A simple work timer that visualizes elapsed work time and earnings down to the millisecond.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple118/v4/3c/af/1c/3caf1cfe-127e-abc2-c5d0-f4f3445d0746/AppIcon-1x_U007emarketing-0-0-GLES2_U002c0-512MB-sRGB-0-0-0-85-220-0-0-0-5.png/100x100bb.jpg",
		appStoreId: "1427753091",
	},
	{
		titleJa: "Simple Shift Calendar",
		titleEn: "Simple Shift Calendar",
		descriptionJa: "必要最小限の機能に絞り、勤務シフトをすばやく入力・確認できるシンプルなカレンダー。",
		descriptionEn: "A focused calendar for quickly entering and checking work shifts with minimal setup.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/7b/80/7a/7b807a3e-7539-adce-410c-d33f74be0d2e/mzl.ivqiktzb.png/100x100bb.jpg",
		appStoreId: "1157592530",
	},
	{
		titleJa: "Simple Shift Pro",
		titleEn: "Simple Shift Pro",
		descriptionJa: "Simple Shift Calendarを広告なしで利用できる買い切り版のシフトカレンダー。",
		descriptionEn: "The ad-free, paid edition of the focused Simple Shift Calendar app.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/7b/80/7a/7b807a3e-7539-adce-410c-d33f74be0d2e/mzl.ivqiktzb.png/100x100bb.jpg",
	},
	{
		titleJa: "Shared Shift Calendar",
		titleEn: "Shared Shift Calendar",
		descriptionJa: "勤務シフトをカレンダーで管理し、他のユーザーと予定を共有するために開発したアプリ。",
		descriptionEn: "A calendar app created for managing work shifts and sharing schedules with other users.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/PurpleSource211/v4/4a/4b/5e/4a4b5e89-69dc-7c77-504c-326c5b862e7a/Placeholder.mill/100x100bb.png",
	},
	{
		titleJa: "Sound Box - 流行りの音を再生",
		titleEn: "Sound Box",
		descriptionJa: "効果音や話題のサウンドをボタン操作ですぐに再生できる、シンプルなサウンドボード。",
		descriptionEn: "A simple soundboard for instantly playing effects and popular audio clips.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/e5/44/ba/e544ba25-b157-1edf-f29c-dab168617b2a/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/100x100bb.jpg",
		appStoreId: "1504106666",
	},
	{
		titleJa: "免許更新",
		titleEn: "License Renewal",
		descriptionJa: "運転免許証の更新日と更新場所を記録し、忘れやすい更新予定を確認できるユーティリティ。",
		descriptionEn: "A utility for recording a driver's-license renewal date and finding the relevant renewal location.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/12/f5/a2/12f5a2fa-95a1-d2e7-5393-49b840cf3afc/AppIcon-0-1x_U007emarketing-0-0-GLES2_U002c0-512MB-sRGB-0-0-0-85-220-0-0-0-6.png/100x100bb.jpg",
		appStoreId: "1458223520",
	},
	{
		titleJa: "Let's お絵描き",
		titleEn: "Let's Draw",
		descriptionJa: "色や線の太さ、消しゴム、Undo・Redo、画像保存に対応したシンプルなお絵描きアプリ。",
		descriptionEn: "A lightweight drawing app with colors, brush sizes, erasing, undo and redo, and image export.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple71/v4/79/0b/07/790b07cc-ddfa-2ba4-d948-7b2dd720cb5b/mzl.ncopszys.jpg/100x100bb.jpg",
		appStoreId: "1116030383",
	},
	{
		titleJa: "TRANS BLUE",
		titleEn: "TRANS BLUE",
		descriptionJa: "Bluetoothを使って近くのiOS端末同士を接続し、音声をやり取りできるトランシーバーアプリ。",
		descriptionEn: "A walkie-talkie app that connects nearby iOS devices over Bluetooth for voice communication.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple62/v4/b1/39/d7/b139d7bf-a2e0-fad7-af84-3b455daf21e4/mzl.iskwftnb.jpg/100x100bb.jpg",
		appStoreId: "1152536999",
	},
	{
		titleJa: "調味量変換",
		titleEn: "Seasoning Converter",
		descriptionJa: "調味料のグラム、計量カップ、計量スプーンの分量を相互変換できる料理ユーティリティ。",
		descriptionEn: "A cooking utility that converts seasoning amounts between grams, measuring cups, and spoons.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple111/v4/17/7c/59/177c596c-038e-dd03-faee-f2e244e16ddd/pr_source.jpg/100x100bb.jpg",
		appStoreId: "1225622767",
	},
	{
		titleJa: "ポケポケ攻略",
		titleEn: "PokePoke Guide",
		descriptionJa: "ゲーム内イベントやカード情報、効率的な進め方をまとめて確認できる攻略情報アプリ。",
		descriptionEn: "A companion app for browsing game events, card information, and strategy guides.",
		logo: null,
	},
	{
		titleJa: "Privacy Blur Photo",
		titleEn: "Privacy Blur Photo",
		descriptionJa: "写真内の見せたくない場所をぼかし、共有前のプライバシー保護を手軽に行える画像加工アプリ。",
		descriptionEn: "A photo utility for quickly blurring sensitive areas before sharing an image.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/PurpleSource211/v4/1b/81/40/1b81402f-8167-ee1c-61f5-e7ffb7bd9e2f/Placeholder.mill/100x100bb.png",
	},
	{
		titleJa: "Checklist Memo",
		titleEn: "Checklist Memo",
		descriptionJa: "メモとチェックリストをシンプルに作成・整理できる、日常向けの記録アプリ。",
		descriptionEn: "A simple everyday app for creating and organizing notes and checklists.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/PurpleSource211/v4/a3/97/0f/a3970f5e-ca49-c141-2538-a382ff9b607a/Placeholder.mill/100x100bb.png",
	},
	{
		titleJa: "遅刻防止アラーム",
		titleEn: "Anti-Lateness Alarm",
		descriptionJa: "出発時刻を意識できるように設計した、遅刻防止のためのアラームアプリ。",
		descriptionEn: "An alarm app designed around departure timing to help users avoid being late.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/PurpleSource211/v4/0c/42/a4/0c42a424-5d96-0551-3d55-663719c6fb41/Placeholder.mill/100x100bb.png",
	},
	{
		titleJa: "any.box",
		titleEn: "any.box",
		descriptionJa: "ブックマーク、テキスト、画像など、形式の異なる情報を一か所へ保存できるストックアプリ。",
		descriptionEn: "A personal inbox for collecting bookmarks, text, images, and other kinds of content in one place.",
		logo: "https://is1-ssl.mzstatic.com/image/thumb/Purple113/v4/e7/97/89/e79789e3-96ad-c4de-cfd4-09aa58d109a3/AppIcon-0-1x_U007emarketing-0-0-GLES2_U002c0-512MB-sRGB-0-0-0-85-220-0-0-0-6.png/100x100bb.jpg",
		appStoreId: "1477410888",
	},
	{
		titleJa: "税込計算・ドル換算電卓",
		titleEn: "Tax & Dollar Calculator",
		descriptionJa: "税込価格の計算とドル換算をすばやく行うために開発したシンプルな電卓アプリ。",
		descriptionEn: "A simple calculator built for quick tax-inclusive price and dollar conversion calculations.",
		logo: null,
	},
	{
		titleJa: "スクワットMax計算",
		titleEn: "Squat Max Calculator",
		descriptionJa: "重量と回数からスクワットの推定最大挙上重量を算出する、筋力トレーニング向け計算機。",
		descriptionEn: "A strength-training calculator that estimates squat one-rep max from weight and repetitions.",
		logo: null,
	},
	{
		titleJa: "PM360",
		titleEn: "PM360",
		descriptionJa: "360度コンテンツを扱うために開発・公開したモバイルアプリ。",
		descriptionEn: "A mobile app created and released for working with 360-degree content.",
		logo: null,
	},
	{
		titleJa: "Olympia - オリンピック総合ポータル",
		titleEn: "Olympia — Olympic Portal",
		descriptionJa: "オリンピックに関するニュースや情報をまとめて確認できる総合ポータルアプリ。",
		descriptionEn: "A portal app for browsing Olympic news and related information in one place.",
		logo: null,
	},
];

const toProjectItem = (item: AppCatalogItem, language: "ja" | "en"): ProjectItem => ({
	title: language === "ja" ? item.titleJa : item.titleEn,
	description: language === "ja" ? item.descriptionJa : item.descriptionEn,
	logo: item.logo,
	linkText: item.appStoreId ? "View on App Store" : "",
	link: item.appStoreId ? `https://apps.apple.com/jp/app/id${item.appStoreId}` : "",
});

// リブランド前から掲載していた非学習アプリの順序は維持し、追加分だけを末尾へ送る。
const previouslyListedTitles = [
	"ThreadMaster",
	"Shiftas+",
	"TapShift - シフト表作成",
	"ペアカレ",
	"Crash Report Viewer",
	"MAX計算機：ベンチプレス・筋トレ1RM",
	"BPM計測：タップ＆自動解析",
	"ルーレット - あなたの決断を後押し",
	"メリーさん",
	"Worker",
	"ポケポケ攻略",
];

const previouslyListedTitleSet = new Set(previouslyListedTitles);
const orderedAppCatalog = [
	...previouslyListedTitles.flatMap((title) => appCatalog.filter((item) => item.titleJa === title)),
	...appCatalog.filter((item) => !previouslyListedTitleSet.has(item.titleJa)),
];

export const appsJa = orderedAppCatalog.map((item) => toProjectItem(item, "ja"));
export const appsEn = orderedAppCatalog.map((item) => toProjectItem(item, "en"));
